import {PaymentItem as PaymentItemModel} from "../../models";
import style from './Payment.module.css';
import {useEffect, useState} from "react";
import PaymentItem from "./PaymentItem";
import Summary from "../../models/summary";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import i18n from "../../i18n";
import {useTranslation} from "react-i18next";
import { logOrderSelectPaymentView } from "../../logging/helpers/commonLoggingFunctions";

export interface Props {
    items: PaymentItemModel[];
    cartId: number;
    cartSummary: Summary;
    loading: boolean,
    payment_secret?:string,
}

const PaymentItemsList = (props: Props) => {
    const {t} = useTranslation()

    const [list, setList] = useState<PaymentItemModel[]>(props.items)
    const [isDisabled,setIsDisabled] = useState<boolean>(false)

    useEffect(() => {
        if (props.items.length > 0)
            setList(props.items)
    }, [props.items])


    useEffect(()=>{
        //logging
        if(props.cartId && props?.items?.length > 0)
            logOrderSelectPaymentView({id: props.cartId});
        //
    }, [props.cartId])

    const isSafari = () => {
        const ua = window.navigator.userAgent;
        return /^((?!chrome|android).)*safari/i.test(ua);
    };

    const isMacOrIOS = () => {
        const ua = window.navigator.userAgent;
        return /Mac|iPod|iPhone|iPad/.test(ua);
    };

    
    return (

        props.loading ? <Skeleton style={{marginTop:"10px"}} count={5} width={"100%"} height={"55px"}/> : <div  dir={i18n.language=='en'?'ltr':'rtl'}  className={style.list_container} style={{backgroundColor:"white",padding:"10px"}}>
            {/*<h3 className={`md_text fw-bold m-2`}>{t('page.payment.title')}</h3>*/}
            {list.map((item, index, allItems) => {
                 if (item.viewType.type === 'applePaySDK' && (!isSafari() || !isMacOrIOS())) { 
                    return <></>;
                }
                return (
                    <div key={index} dir={i18n.language=='en'?'ltr':'rtl'}>
               <PaymentItem key={index} isDisabled={isDisabled} setIsDisabled={setIsDisabled} payment_secret={props.payment_secret} cartSummary={props.cartSummary} cartId={props.cartId}
                                     clearFix={allItems.length - 1 === index} item={item}/>
                    </div>
                )
            })}
        </div>
    )

}

export default PaymentItemsList